import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const CloseIcon = withSvgIcon(
    <path d="M433 119l-52-52-131 131L119 67l-52 52 131 131L67 381l52 52 131-131 131 131 52-52-131-131z" />
);
